export const hot = function () {
  return function (component) {
    return component;
  };
};
